import ViewQuote from './ViewQuote';

export default ViewQuote;



// WEBPACK FOOTER //
// ./src/pages/ViewQuote/index.jsx